import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getReasonLeaveStart,
  getReasonLeaveSuccess,
  getReasonLeaveFailed,
  updateListReason,
} from "../redux/getReasonLeave";
import { getListReasonLeaveApi } from "core/http/service/timeKeeping";

function* getReasonLeaveWork(action) {
  try {
    const res = yield call(getListReasonLeaveApi, action.payload);

    yield put({
      type: getReasonLeaveSuccess.type,
      payload: res,
    });
    yield put({
      type: updateListReason.type,
      payload: {
        type: action.payload,
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getReasonLeaveFailed.type,
    });
  }
}

function* watchGetReasonLeave() {
  yield takeLatest(getReasonLeaveStart.type, getReasonLeaveWork);
}

export default function* getReasonLeaveSaga() {
  yield all([watchGetReasonLeave()]);
}
